import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';
import Stripe from 'stripe';

export interface ApiResponse {
  success: true;
  invoices: {
    history: {
      data: Stripe.Invoice[];
    };
    upcoming: Stripe.Invoice;
  };
}

/**
 * React Query hook to fetch all the available useInvoices for the user from stripe
 * @returns ApiResponse | undefined
 */
const useInvoices = () => {
  const { orgId } = useAuth();
  return useQuery({
    queryKey: [Query.StripeKeys.invoices],
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
    queryFn: async () => {
      const response = await axios.get<ApiResponse>(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/customer/${orgId}/invoices`,
      );
      return response.data.invoices;
    },
  });
};

export { useInvoices };
